import type { ReactNode } from "react";

interface FieldRowProps {
  /** Number of columns on tablet and up. Default 2. */
  columns?: 2 | 3 | 4;
  children: ReactNode;
}

const COLUMN_CLASSES: Record<2 | 3 | 4, string> = {
  2: "sm:grid-cols-2",
  3: "sm:grid-cols-3",
  4: "sm:grid-cols-4",
};

/** Side-by-side layout for fields that stack on narrow screens. */
export function FieldRow({ columns = 2, children }: FieldRowProps) {
  return <div className={`grid grid-cols-1 gap-4 ${COLUMN_CLASSES[columns]}`}>{children}</div>;
}
